import { TFunction } from 'i18next';

export const DEFAULT_TIMES = {
  dueDateTime: { hours: 23, minutes: 59, seconds: 59 },
  startDateTime: { hours: 8, minutes: 0, seconds: 0 },
};

export enum CalendarWidgetPositions {
  LEFT = 'left',
  TOP = 'top',
}

export type Time = {
  hours: number;
  minutes: number;
  seconds: number;
};

export const getAssignmentsErrorMessages = (
  t: TFunction<'translation', undefined>,
) => ({
  UNASSIGN: t('Error: Unassigning failed. Please try again later.'),
  REASSIGN: t('Error: Reassigning failed. Please try again later.'),
  EDIT: t('Error: Editing failed. Please try again later.'),
});
